import { createApp } from 'vue';
import Main from './Main.vue';

const rootElement = document.getElementById('app-delivery-modal');

if (rootElement) {
    createApp(Main).mount(rootElement);
}
